import { render, staticRenderFns } from "./eventsModal.vue?vue&type=template&id=08f9383d&scoped=true&"
import script from "./eventsModal.vue?vue&type=script&lang=js&"
export * from "./eventsModal.vue?vue&type=script&lang=js&"
import style0 from "./eventsModal.vue?vue&type=style&index=0&id=08f9383d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f9383d",
  null
  
)

export default component.exports